// Central data: brand info, menu items, contact, etc.
export const BRAND = {
  name: "GoMill",
  logoFull: "https://customer-assets.emergentagent.com/job_d8950a7e-0e31-4910-bd2c-f329ad33a8c2/artifacts/nj5t1hsj_Asset%205%402x.png",
  logoWhite: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/qov58ql6_Asset%202%403x.png",
  logoIcon: "https://customer-assets.emergentagent.com/job_d8950a7e-0e31-4910-bd2c-f329ad33a8c2/artifacts/7pz3bi13_icon.png",
  heroFood: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/u5c7861r_home%20hero.png",
  heroTruck: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/gid0nlak_03.png",
  truckCity: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/dd1j86xs_02.png",
  doubleDecker: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/shuxelbg_03%20-%20Edited.png",
  kioskScene: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/j46hzmul_03%20%282%29.png",
  tagline: "Guilt-free food. Wherever you are.",
  parent: "EBG Group",
  email: "info@gomill.in",
  phone: "+91 95177 17917",
  whatsapp: "919517717917",
  address: "Hyderabad, India",
  socials: {
    instagram: "https://www.instagram.com/go__mill?igsh=aWN0M21tYmQ3NGpk",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/menu", label: "Menu" },
  { to: "/find", label: "Find GoMill" },
  { to: "/book-event", label: "Book Event" },
  { to: "/about", label: "About" },
  { to: "/franchise", label: "Franchise" },
];

export const CATEGORIES = [
  { id: "all", label: "All Items" },
  { id: "breakfast", label: "Breakfast & Millet Classics" },
  { id: "bowls", label: "Rice & Millet Bowls" },
  { id: "roti", label: "Roti & Curry Combos" },
  { id: "pasta", label: "Pasta & Noodles" },
  { id: "beverages", label: "Beverages" },
];

// Image references from the GoMill-branded shoots (re-used thematically)
const IMG_H1 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/e7cpskld_H1.png";
const IMG_H2 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/nn2f0kpt_H2.png";
const IMG_H3 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/2izy69tq_H3.png";
const IMG_H4 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/19rx3sih_H4.png";
const IMG_H5 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/pnmdtipv_H5.png";
const IMG_H6 = "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/qtjeh35b_H6.png";

export const MENU_ITEMS = [
  // ===== Breakfast & Millet Classics =====
  { id: "b1", name: "Plain Idli", desc: "Steamed, protein-rich multi-millet idlis that are light, wholesome, and nourishing.", category: "breakfast", badges: ["High Protein", "Light"], image: "/menu/Plain%20idli.png" },
  { id: "b2", name: "Podi Idli", desc: "Soft millet idlis tossed in flavorful podi seasoning for a delicious South Indian experience.", category: "breakfast", badges: ["Bestseller"], image: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/l1gzq76d_Podi%20idli.png" },
  { id: "b3", name: "Plain Dosa", desc: "Crispy, fermented five-millet dosa made fresh and served golden brown.", category: "breakfast", badges: ["Classic"], image: "/menu/Plain%20Dosa.png" },
  { id: "b4", name: "Ghee Podi Dosa", desc: "A flavorful millet dosa enriched with ghee and traditional podi spices.", category: "breakfast", badges: ["Bestseller"], image: "/menu/Ghee%20Podi%20Dosa.png" },
  { id: "b5", name: "Masala Dosa", desc: "Classic millet dosa filled with a savory potato masala and served fresh.", category: "breakfast", badges: ["Bestseller"], image: "/menu/Masala%20Dosa.png" },
  { id: "b6", name: "Uttapam", desc: "Thick, fluffy millet pancake topped with fresh vegetables and aromatic seasonings.", category: "breakfast", badges: ["Veggie Loaded"], image: "/menu/Uttapam.png" },
  { id: "b7", name: "Indori Poha", desc: "A wholesome millet-based take on the beloved Indori breakfast favorite.", category: "breakfast", badges: ["Light"], image: "/menu/Indori%20Poha.png" },
  { id: "b8", name: "Pongal", desc: "Comforting mixed-millet porridge cooked to perfection with traditional flavors.", category: "breakfast", badges: ["Comforting"], image: "/menu/Pongal.png" },
  { id: "b9", name: "Poori Aloo", desc: "Golden, puffed millet pooris served with a flavorful potato curry.", category: "breakfast", badges: ["Indulgent"], image: "/menu/Poori%20Aloo.png" },

  // ===== Rice & Millet Bowls =====
  { id: "r1", name: "Dal Khichdi", desc: "A hearty one-pot meal made with wholesome millets and lentils.", category: "bowls", badges: ["Bestseller", "Wholesome"], image: "/menu/Dal%20Khichdi.png" },
  { id: "r2", name: "Lemon Rice", desc: "Zesty and flavorful millet rice tempered with traditional spices.", category: "bowls", badges: ["Zesty"], image: "/menu/Lemon%20Rice.png" },
  { id: "r3", name: "Curd Rice", desc: "A cooling millet and curd preparation that's light, refreshing, and satisfying.", category: "bowls", badges: ["Cooling"], image: "/menu/Curd%20Rice.png" },
  { id: "r4", name: "Rajma Chawal", desc: "Protein-rich kidney beans served over steamed millet grains.", category: "bowls", badges: ["High Protein"], image: "/menu/Rajma%20Chawal.png" },
  { id: "r5", name: "Dal Tadka Chawal", desc: "Tempered lentils paired with nutritious millets for a comforting meal.", category: "bowls", badges: ["Comforting"], image: "/menu/Dal%20Tadka%20Chawal.png" },
  { id: "r6", name: "Veg Biryani / Pulao", desc: "Aromatic millet biryani loaded with vegetables and traditional spices.", category: "bowls", badges: ["Aromatic"], image: "/menu/Veg%20Biryani.png" },

  // ===== Roti & Curry Combos =====
  { id: "c1", name: "Mix Veg Phulka", desc: "Soft multi-millet phulkas served with a delicious mixed vegetable preparation.", category: "roti", badges: ["Wholesome"], image: "/menu/Mix%20Veg%20Phulka.png" },
  { id: "c2", name: "Matar Paneer Phulka", desc: "Creamy paneer and green peas curry paired with nutritious millet phulkas.", category: "roti", badges: ["High Protein"], image: "/menu/Matar%20Paneer%20Phulka.png" },

  // ===== Pasta & Noodles =====
  { id: "p1", name: "Masala Noodles", desc: "Millet noodles tossed in flavorful Indian-style masala seasoning.", category: "pasta", badges: ["Spicy"], image: "/menu/Masala%20Noodles.png" },
  { id: "p2", name: "Mac & Cheese Pasta", desc: "Creamy cheese-coated millet pasta that's rich, comforting, and satisfying.", category: "pasta", badges: ["Kids Love"], image: "/menu/Mac%20%26%20Cheese%20Pasta.png" },
  { id: "p3", name: "White Sauce Pasta", desc: "Multi-millet pasta served in a smooth and creamy white sauce.", category: "pasta", badges: ["Creamy"], image: "/menu/White%20Sauce%20Pasta.png" },
  { id: "p4", name: "Red Sauce Pasta", desc: "Millet pasta tossed in a rich tomato-based sauce with bold flavors.", category: "pasta", badges: ["Tangy"], image: "/menu/Red%20Sauce%20Pasta.png" },
  { id: "p5", name: "Pink Sauce Pasta", desc: "A delightful blend of white and red sauces coating perfectly cooked millet pasta.", category: "pasta", badges: ["Indulgent"], image: "/menu/Pink%20Sauce%20Pasta.png" },

  // ===== Beverages =====
  { id: "v1", name: "Masala Chai", desc: "Traditional Indian tea infused with aromatic spices.", category: "beverages", badges: ["Hot"], image: "/menu/Masala%20Chai.png" },
  { id: "v2", name: "Filter Coffee", desc: "Authentic South Indian filter coffee with a rich and robust flavor.", category: "beverages", badges: ["Hot"], image: "/menu/Filter%20Coffee.png" },
  { id: "v3", name: "Buttermilk (Chaas)", desc: "Refreshing spiced buttermilk made to complement every meal.", category: "beverages", badges: ["Refreshing"], image: "/menu/Buttermilk%20%28Chaas%29.png" },
  { id: "v4", name: "Roohafzah Sherbet", desc: "A refreshing rose-flavored beverage perfect for cooling down.", category: "beverages", badges: ["Cool"], image: "/menu/Roohafzah%20Sherbet.png" },
];

// IDs to feature in the home page "Signature Picks" section
export const SIGNATURE_IDS = ["r1", "b5", "c1", "r4", "b1", "b6"];

export const MEAL_PLANS = [
  {
    id: "plan-essential",
    name: "Daily Essential",
    price: 89,
    unit: "/meal",
    desc: "One wholesome millet meal, every working day.",
    bullets: ["1 meal / day", "Mon–Fri", "Minimum 20 meals", "Veg & Non-Veg"],
    tag: "Best for Offices",
    highlight: false,
  },
  {
    id: "plan-complete",
    name: "Daily Complete",
    price: 159,
    unit: "/meal",
    desc: "Lunch + snack box, balanced macros, chef-curated.",
    bullets: ["2 meals / day", "Mon–Sat", "Customisable", "Nutritionist Curated"],
    tag: "Most Popular",
    highlight: true,
  },
  {
    id: "plan-fuel",
    name: "All Day Fuel",
    price: 219,
    unit: "/meal",
    desc: "Breakfast, lunch and a recovery snack for fitness teams.",
    bullets: ["3 meals / day", "High protein", "Gym partner", "Same-day swaps"],
    tag: "For Gyms",
    highlight: false,
  },
  {
    id: "plan-weekly",
    name: "Weekly Plan",
    price: 1599,
    unit: "/week",
    desc: "A full week of guilt-free meals delivered to your campus.",
    bullets: ["7 days", "Rotating menu", "Festival specials", "Bulk billing"],
    tag: "For Colleges",
    highlight: false,
  },
];

export const FRANCHISE_FORMATS = [
  {
    id: "kiosk",
    name: "GoMill Kiosk",
    desc: "Compact 80–120 sqft kiosk format for malls, offices and campuses.",
    footprint: "80–120 sqft",
    invest: "₹ 20,00,000",
    image: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/j46hzmul_03%20%282%29.png",
  },
  {
    id: "single-tier",
    name: "GoMill Food Truck",
    desc: "Our flagship mobile kitchen for neighbourhoods and event circuits.",
    footprint: "Single deck truck",
    invest: "₹ 35,00,000",
    image: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/dd1j86xs_02.png",
  },
  {
    id: "double-decker",
    name: "GoMill Double-Decker",
    desc: "A showstopper double-decker for premium locations and festivals.",
    footprint: "Premium double-deck",
    invest: "₹ 50,00,000",
    image: "https://customer-assets.emergentagent.com/job_gomill-healthy-bites/artifacts/gid0nlak_03.png",
  },
];

export const EVENT_TYPES = [
  "College Pop-Up",
  "Office Lunch Spot",
  "Corporate Catering",
  "Apartment Activation",
  "Festival Food Zone",
  "Sports Event",
];

export const COMMUNITY_FORMATS = [
  { title: "Weekly Truck Visits", desc: "A recurring food-truck day for your gated community." },
  { title: "Clubhouse Food Days", desc: "Pop-up kiosk for the clubhouse on weekends." },
  { title: "Festive & Themed", desc: "Holi, Diwali, Independence Day curated menus." },
  { title: "Wellness Drives", desc: "Millet education + tasting + nutrition sessions." },
];
